import { $vars } from '../../../config/vars';
import { the_language } from '../../y/i18n';
import { yLoadAsyncScript } from '../../y/util';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';

export namespace $recaptcha {
    let recaptcha_promise: Promise<void> | undefined;

    const config = $vars.recaptcha;

    export function makeWarning(classes?: UIClassesSpec) {
        if(the_language == 'sv') {
            return $el.SPAN(classes, ['Den här webbplatsen skyddas av reCAPTCHA och Googles ', $el.A('https://policies.google.com/privacy', 'sekretesspolicy', 't-underline'), ' och ', $el.A('https://policies.google.com/terms', 'användarvillkor', 't-underline'), ' gäller.']);
        } else if(the_language == 'de') {
            return $el.SPAN(classes, ['Diese Website ist durch reCAPTCHA geschützt und es gelten die ', $el.A('https://policies.google.com/privacy', 'Datenschutzbestimmungen', 't-underline'), ' och ', $el.A('https://policies.google.com/terms', 'Nutzungsbedingungen', 't-underline'), ' von Google.']);
        } else {
            return $el.SPAN(classes, ['This site is protected by reCAPTCHA and the Google ', $el.A('https://policies.google.com/privacy', 'Privacy Policy', 't-underline'), ' and ', $el.A('https://policies.google.com/terms', 'Terms of Service', 't-underline'), ' apply.']);
        }
    }

    export function init() {
        if(!recaptcha_promise) {
            let url = 'https://www.google.com/recaptcha/enterprise.js';

            if(config.v3_key) {
                url += '?render=' + config.v3_key;
            }

            recaptcha_promise = yLoadAsyncScript(url);
        }

        return recaptcha_promise;
    }

    export function execute(action: string) {
        return init().then(() => {
            if(!config || !config.v3_key) throw 'Recaptcha key not loaded';

            return grecaptcha.enterprise.execute(config.v3_key, { action });
        });
    }
}
